import { useSites } from '../../../context/SiteContext';
import { useReportVisits } from '../../../hooks/useReportVisits';
import { buildPages } from '../../../lib/analytics';
import { formatNumber } from '../../../lib/format';
import EmptyState from '../../../components/dashboard/EmptyState';
import PageHeader from '../../../components/dashboard/PageHeader';
import StatTable from '../../../components/dashboard/StatTable';
import ExportButton from '../../../components/dashboard/ExportButton';

export default function ExitPage() {
  const { currentSite } = useSites();
  const { ranged, range } = useReportVisits(currentSite);
  const pages = buildPages(ranged).filter((p) => p.exit > 0).sort((a, b) => b.exit - a.exit);
  const columns = ['出口页面', '离开次数', '浏览量', '访客'];
  const rows = pages.map((p) => [p.path, formatNumber(p.exit), formatNumber(p.pv), formatNumber(p.uv)]);

  if (!currentSite) return <EmptyState title="先添加一个站点" desc="添加站点后可查看出口页。" />;

  return (
    <div>
      <PageHeader
        title="出口页面"
        desc="访客离开网站前停留的最后一页，便于发现流失点。"
        range={range}
        extra={<ExportButton filename={`${currentSite.domain}-exit.csv`} columns={columns} rows={rows} />}
      />
      <div className="mt-6 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
        <StatTable columns={columns} rows={rows} empty="当前时段暂无出口页数据" />
      </div>
    </div>
  );
}
